module.exports = __webpack_public_path__ + "img/icon-9.a0a21134.png";